module.exports = __webpack_public_path__ + "static/media/loading_icon.8f1f830e.png";